import { AuthUser, getCurrentUser } from "aws-amplify/auth";
import { useEffect } from "react";

import { loadUserProperties } from "@/services/authService.ts";

import { useAuthStore } from "@/stores/authStore.ts";

const useLoadUser = (): void => {
    useEffect(() => {
        const loadUser = async (): Promise<void> => {
            let user: AuthUser | undefined;
            try {
                user = await getCurrentUser();
            } catch (error) {
                console.debug({ error });
            }
            await loadUserProperties();
            useAuthStore.setState({ user: user, isUserSet: true });
        };
        void loadUser();
    }, []);
};

export default useLoadUser;
